import {ObjectId} from 'bson';
import {
  GetEnrichedFieldCount,
  GetIsEnrichingAgent,
  GetNumAccountsToEnrichDefinition,
  RunEnrichmentDefinition,
} from '../../shared/api/definitions/root';
import {createApiQuery, useApiMutation} from './api';
import {useQueryClient} from '@tanstack/react-query';
import {EnrichmentPreviewResultQueryKeys} from './fieldDefinitionPreview';

export const IsEnrichingAgentQueryKeys = {
  all: ['isEnrichingAgent'] as const,
  agent: (agentId: ObjectId) =>
    [...IsEnrichingAgentQueryKeys.all, agentId.toString()] as const,
};
export const useIsEnrichingAgent = createApiQuery(
  GetIsEnrichingAgent,
  ({agentId}) => IsEnrichingAgentQueryKeys.agent(agentId),
  {
    refetchInterval: (query) => {
      return query.state.data ? 1_000 : 0;
    },
  }
);

export const useNumAccountsToEnrich = () => {
  return useApiMutation(GetNumAccountsToEnrichDefinition);
};

export const useRunEnrichment = () => {
  const queryClient = useQueryClient();

  return useApiMutation(RunEnrichmentDefinition, {
    onSuccess: async () => {
      // can't surgically invalidate the keys for the field definition because there might be depdendent
      // fields that also end up getting run
      await queryClient.invalidateQueries({
        queryKey: IsEnrichingAgentQueryKeys.all,
      });
      await queryClient.invalidateQueries({
        queryKey: EnrichmentPreviewResultQueryKeys.all,
      });
    },
  });
};

export const EnrichedFieldCountQueryKeys = {
  all: ['enrichedFieldCount'] as const,
  field: (fieldDefinitionId: ObjectId) =>
    [...EnrichedFieldCountQueryKeys.all, fieldDefinitionId.toString()] as const,
};

export const useEnrichedFieldCount = createApiQuery(
  GetEnrichedFieldCount,
  ({fieldDefinitionId}) => EnrichedFieldCountQueryKeys.field(fieldDefinitionId)
);
